
import { defineComponent } from 'vue';
import ESARSite from '@/models/ESARSite';

export default defineComponent({
    name: 'RiskManagement',
    components: {},
    props: {
        siteDetails: ESARSite
    },
    setup(props) {
        const onSiteData = props.siteDetails?.riskManagementData.find((x) => x.RMPLocation === 'OnSite');
        const offSiteData = props.siteDetails?.riskManagementData.find((x) => x.RMPLocation === 'OffSite');

        const setToNAIfNotSet = function (v: string | undefined): string {
            if (!v) {
                return 'Not Applicable';
            }
            return v;
        };

        const data = [
            { title: 'Is there an approved RMP in place?', offsite: setToNAIfNotSet(offSiteData?.approvedRMPInPlace), onsite: setToNAIfNotSet(onSiteData?.approvedRMPInPlace) },
            { title: 'DUA Exclusion', offsite: setToNAIfNotSet(offSiteData?.DUA), onsite: setToNAIfNotSet(onSiteData?.DUA) },
            { title: 'FAL Exclusion', offsite: setToNAIfNotSet(offSiteData?.FAL), onsite: setToNAIfNotSet(onSiteData?.FAL) },
            { title: 'Management Limit', offsite: setToNAIfNotSet(offSiteData?.managementLimit), onsite: setToNAIfNotSet(onSiteData?.managementLimit) },
            { title: 'Ecological Direct Soil Contact', offsite: setToNAIfNotSet(offSiteData?.ecologicalDirectSoilContact), onsite: setToNAIfNotSet(onSiteData?.ecologicalDirectSoilContact) },
            { title: 'Vapour Inhilation', offsite: setToNAIfNotSet(offSiteData?.vapourInhalation), onsite: setToNAIfNotSet(onSiteData?.vapourInhalation) },
            { title: 'Others', offsite: setToNAIfNotSet(offSiteData?.others), onsite: setToNAIfNotSet(onSiteData?.others) },
            { title: 'Administrative Controls', offsite: setToNAIfNotSet(offSiteData?.administrativeControl), onsite: setToNAIfNotSet(onSiteData?.administrativeControl) },
            { title: 'Exposure Barriers', offsite: setToNAIfNotSet(offSiteData?.exposureBarriers), onsite: setToNAIfNotSet(onSiteData?.exposureBarriers) },
            // { title: 'Monitoring Report Due Date (D-M-Y)', offsite: '2011', onsite: '2011' },
        ];

        return { data };
    }
});
